"use client";
/* eslint-disable react/display-name */
import React, { useState } from "react";
import withMaskedTextField from "./MaskedTextField/MaskedTextField.helpers";
import { withFacTextField } from "./FacTextField.helpers";
import { FacTextFieldProps } from "./FacTextField.type";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import FacTextField from "./FacTextField.component";

export const FacTextFieldCNPJ = withMaskedTextField(
    {
        inputProps: { maxLength: 18 },
        label: "CNPJ",
        placeholder: "00.000.000/0000-00",
        name: "cnpj",
    },
    {
        mask: "00.000.000/0000-00",
        inputMode: "numeric",
    },
);

export const FacTextFieldCPF = withMaskedTextField(
    {
        inputProps: { maxLength: 14 },
        label: "CPF",
        placeholder: "000.000.000-00",
        name: "cpf",
    },
    {
        mask: "000.000.000-00",
        inputMode: "numeric",
    },
);

export const FacTextFieldPhone = withMaskedTextField(
    {
        placeholder: "(99) 99999-9999",
        type: "tel",
        label: "Telefone",
        name: "phone",
    },
    {
        mask: "(00) 00000-0000",
    },
);

export const FacTextFieldCompany = withFacTextField({
    label: "Nome da Empresa",
    inputProps: { maxLength: 80 },
    name: "company",
});

export const FacTextFieldUserName = withFacTextField({
    label: "Nome de Usuário",
    inputProps: { maxLength: 80 },
    name: "username",
});

export const FacTextFieldPassword = ({
    label = "Senha",
    inputProps,
    InputProps,
    InputLabelProps,
    disabled,
    ...props
}: FacTextFieldProps) => {
    const [togglePassword, setTogglePassword] = useState<boolean>(false);

    return (
        <FacTextField
            label={label}
            type={togglePassword ? "text" : "password"}
            inputProps={{
                maxLength: 80,
                ...inputProps,
            }}
            disabled={disabled}
            InputLabelProps={{ shrink: true, ...InputLabelProps }}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            disabled={disabled}
                            aria-label="toggle password visibility"
                            onClick={() => setTogglePassword(!togglePassword)}
                            edge="end"
                        >
                            {togglePassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                ),
                ...InputProps,
            }}
            {...props}
        />
    );
};

export const FacTextFieldEmail = withFacTextField({
    label: "Email",
    type: "email",
    name: "email",
    inputProps: { maxLength: 120 },
});

export const FacTextFieldCity = withFacTextField({
    label: "Cidade",
    name: "city",
    inputProps: { maxLength: 120 },
});

export const FacTextFieldState = withFacTextField({
    label: "Estado",
    name: "state",
    inputProps: { maxLength: 120 },
});
